import { Info } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { useGameVersion } from '../hooks/useGameVersion'

interface Props {
  context: 'profile'
  className?: string
}

const ManualSyncNotice = ({ context, className }: Props) => {
  const { t } = useTranslation()
  const gameVersion = useGameVersion()

  if (gameVersion.has('blizzard_api')) return null

  return (
    <Alert variant='info' className={className}>
      <Info size={16} />
      <AlertTitle>{t('manual-sync.title')}</AlertTitle>
      <AlertDescription>{t(`manual-sync.${context}`)}</AlertDescription>
    </Alert>
  )
}

export default ManualSyncNotice
